import { render } from "./GiftCards.vue?vue&type=template&id=7846f1a6&scoped=true"
import script from "./GiftCards.vue?vue&type=script&lang=js"
export * from "./GiftCards.vue?vue&type=script&lang=js"

import "./GiftCards.vue?vue&type=style&index=0&id=7846f1a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7846f1a6"],['__file',"src/views/GiftCards/GiftCards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7846f1a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7846f1a6', __exports__)) {
    api.reload('7846f1a6', __exports__)
  }
  
  module.hot.accept("./GiftCards.vue?vue&type=template&id=7846f1a6&scoped=true", () => {
    api.rerender('7846f1a6', render)
  })

}


export default __exports__